import type { AdTokenNote } from "./adTokenScan";

/**
 * What a note asks of the writer -- the one place that decides it (MPN-1933).
 *
 *   warning -- probably a mistake: an unknown token. Counted in Create Studio's header.
 *   info    -- resolves, but there is a better spelling: an alias.
 *   todo    -- a copywriter instruction. Not a mistake in a template, where the bracket is
 *              the point; unfinished work in a concrete ad. Which of those a given editor is
 *              looking at is a policy Ops has not settled yet; when they do, it changes here.
 */
export type AdTokenSeverity = "warning" | "info" | "todo";

export function adTokenSeverity(kind: AdTokenNote["kind"]): AdTokenSeverity {
    if (kind === "unknown") return "warning";
    if (kind === "instruction") return "todo";
    return "info";
}
